export default __webpack_public_path__ + "static/media/Banner_image_CSI_DH_small.aa3d56be.jpg";